import { render, staticRenderFns } from "./toexamine.vue?vue&type=template&id=bcac1596&scoped=true&"
import script from "./toexamine.vue?vue&type=script&lang=js&"
export * from "./toexamine.vue?vue&type=script&lang=js&"
import style0 from "./toexamine.vue?vue&type=style&index=0&id=bcac1596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcac1596",
  null
  
)

export default component.exports